"use strict";

define('view/notifications/instant.notification',['marionette', 'uikit/elements/button', 'uikit/mixins/component.mixin', '../../templates'], function (Mn, ButtonView, ComponentMixin, Templates) {
  var NotificationTimeout = 60000;
  var NotificationActions = Mn.CollectionView.extend({
    className: 'ui tiny vertical inverted basic buttons',
    childView: ButtonView,
    childViewEventPrefix: 'action',
    childViewOptions: {
      bindings: {
        text: 'text',
        color: 'color',
        link: 'link'
      }
    }
  });
  var InstantNotification = Mn.ItemView.extend(ComponentMixin).extend({
    className: 'ui raised fitted segment notification',
    template: Templates.IRB['instant.notification'],
    options: {
      autoClose: true,
      icon: null,
      iconColor: 'white',
      fluid: false,
      title: '',
      details: '',
      actions: null,
      secondaryAction: null
    },
    bindings: {
      autoClose: 'autoClose',
      fluid: 'fluid',
      icon: 'icon',
      iconColor: 'iconColor',
      title: 'title',
      details: 'details',
      secondaryAction: 'secondaryAction'
    },
    attributes: {
      style: 'display: none; background: rgba(0, 0, 0, 0.8);'
    },
    ui: {
      'actions': '.actions-column',
      'content': '.content-column',
      'content-text': '.content-column .ui.header',
      'icon': '.icon-column'
    },
    initialize: function initialize() {
      ComponentMixin.initialize.apply(this, arguments);
      this._actions = new Backbone.Collection([]);
    },
    getActions: function getActions() {
      var actions = this._actions;
      actions.reset([]);
      actions.push({
        text: 'Close'
      });
      if (this.getOption('secondaryAction')) {
        actions.push(this.getOption('secondaryAction'));
      }
      return actions;
    },
    onPress: function onPress() {},
    onRender: function onRender() {
      var self = this;
      this.renderActions();
      _.defer(function () {
        self.show({
          force: true,
          animation: 'slide left'
        });
      });
    },
    onShow: function onShow() {
      var self = this;
      if (this.getOption('autoClose')) {
        setTimeout(function () {
          if (self.visible) {
            self.close();
          }
        }, NotificationTimeout);
      }
    },
    hide: function hide(options) {
      var self = this;
      options = _.extend({
        animation: 'slide left',
        onComplete: function onComplete() {
          self.triggerMethod('animate:complete');
        }
      }, options);
      return ComponentMixin.hide.call(this, options);
    },
    close: function close() {
      var self = this;
      this.hide({
        onComplete: function onComplete() {
          self.triggerMethod('close');
        }
      });
    },
    renderActions: function renderActions() {
      var self = this,
        actions = new NotificationActions({
          collection: this.getActions()
        });
      this.ui.actions.html(actions.$el);
      actions.render();
      actions.on('action:press', function (a) {
        var action = a.model.get('action');
        if (action) {
          self.triggerMethod(action);
        }
        self.close();
      });
    },
    updateAttributes: function updateAttributes() {
      this.addClass('fluid', this.getOption('fluid'));
    }
  });
  var InstantNotificationModel = Backbone.Model.extend({
    defaults: {
      autoClose: false,
      fluid: false,
      icon: null,
      iconColor: 'white',
      title: '',
      details: '',
      secondaryAction: null
    }
  });
  InstantNotification.Model = InstantNotificationModel;
  return InstantNotification;
});

